import {Component, HostListener, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {Router} from "@angular/router";

@Component({
  selector: 'app-aarni-school-of-education-and-sports',
  templateUrl: './aarni-school-of-education-and-sports.component.html',
  styleUrls: ['./aarni-school-of-education-and-sports.component.scss']
})
export class AarniSchoolOfEducationAndSportsComponent implements OnInit {
    testimonialSlideIndex: number = 0;
    testimonialSlidesCount: number = 3;
    groupedTestimonials: any[][] = [];
    testimonials = [
        {
            name: 'Pallavi Chauhan',
            course: 'M.sc. - Physics',
            designation: 'J&K Bank',
            image: 'assets/img/home-page-testimonials/pallavi-chauhan.webp',
            feedback: `ARNI University provides an excellent platform to those who have an interest in
                                    research and technology. The professors are well-mannered and talented, ensure
                                    student growth. The laboratory is equipped with all the necessary equipments. The
                                    emphasis on research ethics and
                                    innovation has given me the confidence to pursue my dream of contributing to
                                    physical advancements.`,
        },
        {
            name: 'Punchok Lamo',
            course: 'M.Sc. - Physics',
            designation: 'Govt. Teacher',
            image: 'assets/img/home-page-testimonials/punchok-lamo.webp',
            feedback: `Throughout my learning journey at ARNI University, I was always encouraged to focus
                                    on practical learning. The faculty organized science fairs, conducted open
                                    experiment classes, analyzed our data, and helped to develop critical thinking
                                    skills. Lectures from industry experts keep us updated with real-world scenarios and
                                    boost our confidence.`,
        },
        {
            name: 'Vinit Gupta',
            course: 'Diploma in Pharmacy',
            designation: 'Garg Pharma',
            image: 'assets/img/home-page-testimonials/vinit-gupta.webp',
            feedback: `I was a little nervous and worried about the course curriculum when I joined this
                                    program. But the best student support and world-class faculty made everything easy
                                    and synchronized for me. The faculty members are absolutely knowledgeable and always
                                    ready to help whenever required. Apart from theoretical learning, they focus on
                                    applying what we learn. I had a great time here!`,
        },
        {
            name: 'Geetika Katoch',
            course: 'MBA in HR',
            designation: 'Hitech Engineering Industry, Malot',
            image: 'assets/img/home-page-testimonials/geetika-katoch.webp',
            feedback: `  The professors at ARNI are not just teachers; they are mentors who guide you at
                                    every step. Their real-world experience and industry insights make learning so much
                                    more engaging. Thanks to their career counseling, I was able to choose the right
                                    specialization for my MBA!`,
        },
        {
            name: 'Harshal Singh Thakur',
            course: 'B. Tech CSE',
            designation: 'Genpact Bengaluru',
            image: 'assets/img/home-page-testimonials/harshal-singh.webp',
            feedback: `Apart from the studies and their positive behavior towards students, the one thing I loved about this university is its placement services. They have collaborated with big companies, which helps students to get real-world experience and internships with minimum effort.`,
        },
    ];

   /* testimonials = [
        {
            name: 'Vikram Singh',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/51.jpg',
            feedback: `Being a student of ARNI has been a truly enriching experience. We regularly participate in teaching demonstrations, group discussions, and classroom simulations, which help us understand how to actually engage students in real classrooms.`,
        },
        {
            name: 'Aisha Gupta',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/women/51.jpg',
            feedback: `I chose ARNI because I wanted a university that respected both academics and athletics, and I was right! From professionally trained coaches to immaculate grounds, the sports facilities are excellent. Here, I've developed significantly as an athlete while maintaining my academic progress. They offer the ideal balance.`,
        },
        {
            name: 'Ravi Sharma',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/52.jpg',
            feedback: `The real foundation of ARNI is its sports instructors. They constantly encourage us to perform better and are very personable and supportive. They act as mentors to us, helping us with everything from lesson planning to exam or event preparation. I'm constantly inspired to set higher goals.`,
        },
        {
            name: 'Meera Joshi',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/women/52.jpg',
            feedback: `What I love most about studying here is how the program focuses on overall development. We get opportunities to participate in cultural events, debates, community teaching programs, and sports events. It has helped me become more confident, expressive, and balanced as a person.`,
        },
        {
            name: 'Arjun Patel',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/53.jpg',
            feedback: `The professors are not only degree-oriented; they nurture your skills to train you for the future. We gain experience in a variety of settings, including seminars on education policy and teaching internships in reputable schools. The placement cell is very active and assists us in establishing connections.`,
        },
        {
            name: 'Neha Verma',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/women/42.jpg',
            feedback: `The classrooms are well-equipped, the sports grounds are vast, and there’s always something happening—from inter-college matches to teaching workshops. It’s a vibrant campus that keeps you inspired every day. Placement cells collaborate with educational institutions that need qualified teachers.`,
        }
    ];*/
    events = [
        {
            date: '04 Nov 2023',
            title: 'Spandan Sports Festival',
            description: 'A total of 318 participants from 12 schools and 4 colleges. The Event was inaugurated by Honourable Chancellor Dr. Vivek Singh on November 27.',
            image: 'assets/img/school-wise-faculties/arni-school-of-sports/events/event1-spandan-sports-meet.webp'
        },
        {
            date: '29 Aug 2023',
            title: 'Sports Day Celebration',
            description: 'ARNI University celebrated National Sports Day on 29th August 2023 with great enthusiasm, promoting fitness, teamwork, and the spirit of sportsmanship.',
            image: 'assets/img/school-wise-faculties/arni-school-of-sports/events/event2-national-sports-day.webp'
        },
        {
            date: '29 Aug 2023',
            title: 'Sports Day Celebration',
            description: 'A day filled with energy and action! ARNI University marked National Sports Day 2023 with thrilling competitions and inspiring student participation.',
            image: 'assets/img/school-wise-faculties/arni-school-of-sports/events/event-3-national-sports-day.webp'
        },
    ];
    departments = [
        {
            name: 'Education & Sports',
            icon: 'fa-dumbbell',
            branches: [
                'Bachelor of Physical Education & Sports',
            ]
        }
    ];
    faculties = [
        {
            name: 'Mr. Narendra Pal',
            designation: 'Professor & Head of the Department',
            image: 'assets/img/school-wise-faculties/arni-school-of-sports/mr-narendra-pal-arni-school-of-education-and-sports.webp',
        },
    ];
    index = 0;
    recruiters = [
        { name: "Adani Wilmar", logo: "assets/img/companies/adani_wilmar.png" },
        { name: "Amar Ujala", logo: "assets/img/companies/amarujala.png" },
        { name: "Amazon", logo: "assets/img/companies/Amazon.png" },
        { name: "CMC", logo: "assets/img/companies/cmc-logo_0.png" },
        { name: "Dish TV", logo: "assets/img/companies/Dish_TV_2.png" },
        { name: "Future Group", logo: "assets/img/companies/FutureGroup.png" },
        { name: "HCL", logo: "assets/img/companies/hcl.png" },
        { name: "ICICI", logo: "assets/img/companies/icici_securities.png" },
        { name: "Sleepwell", logo: "assets/img/companies/sleepwell.png" },
        { name: "SYNTEL", logo: "assets/img/companies/syntel2.png" },
        {
            name: "Tech Mahindra",
            logo: "assets/img/companies/Tech_Mahindra_New_Logo1.png",
        },
        { name: "Vodafone", logo: "assets/img/companies/Vodafone_logo.png" },
        { name: "Zee TV", logo: "assets/img/companies/Zee_TV_2011.png" },
        { name: "Genpact", logo: "assets/img/companies/zenpact.png" },
        { name: "Reliance", logo: "assets/img/companies/amarujala.png" },
    ];

    nextSlide() {
        if (this.index < this.recruiters.length - 3) {
            this.index++;
        }
    }

    prevSlide() {
        if (this.index > 0) {
            this.index--;
        }
    }

    currentIndex = 0;
    translateX = 0;

    constructor(
        private meta: Meta,
        private titles: Title,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.updateMetaTags();
        this.scrollToContent();
        this.groupTestimonials();
    }

    @HostListener('window:resize')
    onResize() {
        this.groupTestimonials();
    }

    groupTestimonials(): void {
        const screenWidth = window.innerWidth;
        let perSlide = 1;
        if (screenWidth >= 1024) {
            perSlide = 3;
        } else if (screenWidth >= 768) {
            perSlide = 2;
        } else {
            perSlide = 1;
        }
        const grouped = [];
        for (let i = 0; i < this.testimonials.length; i += perSlide) {
            grouped.push(this.testimonials.slice(i, i + perSlide));
        }
        this.groupedTestimonials = grouped;
        if (this.testimonialSlideIndex >= this.groupedTestimonials.length) {
            this.testimonialSlideIndex = 0;
        }
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    scrollToContent() {
        const tabs = document.querySelectorAll('.tab-link');
        const tabContainer = document.querySelector('.tab-buttons'); // tab buttons wrapper
        const header = document.querySelector('header'); // your fixed header element, if any

        const tabHeight = tabContainer?.getBoundingClientRect().height || 0;
        const headerHeight = header?.getBoundingClientRect().height || 0;

        const totalOffset = tabHeight + headerHeight + 15; // add extra padding to show section clearly

        tabs.forEach(tab => {
            tab.addEventListener('click', (event: Event) => {
                event.preventDefault();

                tabs.forEach(t => t.classList.remove('active-tab'));
                (event.target as HTMLElement).classList.add('active-tab');

                const targetId = (event.target as HTMLElement).getAttribute('href')?.substring(1);
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const y = targetElement.getBoundingClientRect().top + window.pageYOffset - totalOffset;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                }
            });
        });
    }


    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.translateX = -this.currentIndex * 25; // Move 25% left
        }
    }

    next() {
        if (this.currentIndex < this.faculties.length - 1) {
            this.currentIndex++;
            this.translateX = -this.currentIndex * 25; // Move 25% right
        }
    }

    setTestimonialSlide(index: number) {
        this.testimonialSlideIndex = index;
    }

    updateMetaTags() {
        this.titles.setTitle('Undergraduate Courses for Science Students at ARNI School');
        this.meta.updateTag({
            name: 'description',
            content: `Explore undergraduate courses for science students at ARNI School of Education & Sports. Prepare for a successful career with a top-tier education and hands-on experience.`
        });
    }
}
